import axios from 'axios';

const API_BASE_URL = '/api/lead-activity-logs';

// Fetch activity logs for a lead
export const fetchActivityLogs = async (leadId) => {
  try {
    const response = await axios.get(API_BASE_URL + '/' + leadId);
    return response.data;
  } catch (error) {
    console.error('Error fetching activity logs:', error);
    throw error;
  }
};

// Add a new activity log for a lead
export const addActivityLog = async (leadId, activityType, description) => {
  try {
    const response = await axios.post(API_BASE_URL, {
      lead_id: leadId,
      activity_type: activityType,
      description,
    });
    return response.data;
  } catch (error) {
    console.error('Error adding activity log:', error);
    throw error;
  }
};
